import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "daum-postcode-dialog" }
const _hoisted_2 = { class: "daum-postcode-dialog__header" }
const _hoisted_3 = { class: "daum-postcode-dialog__body" }
const _hoisted_4 = {
  key: 0,
  class: "daum-postcode-dialog__loading"
}

import { ref, watch, nextTick } from 'vue';

export interface DaumPostcodeResult {
  zonecode: string;
  address: string;
  roadAddress: string;
  jibunAddress: string;
  buildingName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DaumPostcodeDialog',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const containerRef = ref<HTMLDivElement | null>(null);
let scriptLoading: Promise<void> | null = null;

const loadScript = (): Promise<void> => {
  if ((window as any).daum?.Postcode) return Promise.resolve();
  if (scriptLoading) return scriptLoading;
  scriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  return scriptLoading;
};

const close = () => {
  emit('update:modelValue', false);
};

const onDialogToggle = (val: boolean) => {
  if (!val) close();
};

const embed = async () => {
  loading.value = true;
  try {
    await loadScript();
    await nextTick();
    const container = containerRef.value;
    if (!container) throw new Error('container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress || '';
        const jibun = data.jibunAddress || '';
        emit('select', {
          zonecode: data.zonecode || '',
          address: road || jibun || '',
          roadAddress: road,
          jibunAddress: jibun,
          buildingName: data.buildingName || '',
        });
        close();
      },
      onresize: (size: any) => {
        if (container && size?.height) {
          container.style.height = `${size.height}px`;
        }
      },
      width: '100%',
      height: '100%',
    }).embed(container, { autoClose: true });
    loading.value = false;
  } catch (e) {
    loading.value = false;
    close();
    alert('주소 검색을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
  }
};

watch(
  () => props.modelValue,
  (val) => {
    if (val) embed();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "520",
    persistent: "",
    "content-class": "daum-postcode-dialog-shell",
    "onUpdate:modelValue": onDialogToggle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", null, "주소 검색", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "daum-postcode-dialog__close",
            "aria-label": "닫기",
            onClick: close
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary",
                  size: "40"
                }),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "주소 검색을 불러오는 중...", -1))
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", {
            ref_key: "containerRef",
            ref: containerRef,
            class: "daum-postcode-dialog__embed"
          }, null, 512), [
            [_vShow, !loading.value]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})